"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartRangeDropDownPicker = void 0;
var React = require("react");
var react_popper_1 = require("react-popper");
var Modal_1 = require("../../ReactPortalWrapper/Modal");
var ChartRangeDropdownPicker_context_1 = require("./ChartRangeDropdownPicker.context");
var ChartRangeDropDownPicker_styles_1 = require("./ChartRangeDropDownPicker.styles");
var DropdownButton_1 = require("./Components/DropdownButton");
var DropdownWrap_1 = require("./Components/DropdownWrap");
var ChartRangeDropDownPicker = function (props) { return (React.createElement(ChartRangeDropdownPicker_context_1.ChartRangeDropdownPickerProvider, { value: props },
    React.createElement(Control, null))); };
exports.ChartRangeDropDownPicker = ChartRangeDropDownPicker;
var useOverlayLayer = function (onClick) {
    return {
        Overlay: function () { return React.createElement(ChartRangeDropDownPicker_styles_1.OverlayDiv, { onClick: onClick }); },
    };
};
var Control = function () {
    var isDropdownOpen = ChartRangeDropdownPicker_context_1.useStateContext().isDropdownOpen;
    var dispatch = ChartRangeDropdownPicker_context_1.useDispatchContext().dispatch;
    var Overlay = useOverlayLayer(function () {
        if (isDropdownOpen) {
            dispatch({ type: "cancel" });
        }
    }).Overlay;
    return (React.createElement(react_popper_1.Manager, null,
        React.createElement(react_popper_1.Reference, null, function (_a) {
            var ref = _a.ref;
            return (React.createElement("div", { ref: ref },
                React.createElement(DropdownButton_1.DropdownButton, null)));
        }),
        isDropdownOpen && (React.createElement(Modal_1.Modal, { DisableAutoFocus: true },
            React.createElement(react_popper_1.Popper, { placement: "bottom-end" }, function (_a) {
                var ref = _a.ref, style = _a.style;
                return (React.createElement(React.Fragment, null,
                    React.createElement(Overlay, null),
                    React.createElement("div", { ref: ref, style: style },
                        React.createElement(DropdownWrap_1.DropdownWrap, null))));
            })))));
};
